const radioStyles = (tokens) => ({
    baseStyle: {
        container: {
            borderColor: tokens.BorderPrimary,
        },
        control: {
            width: tokens.Spacing06,
            height: tokens.Spacing06,
            bg: 'transparent',
            borderColor: tokens.BorderPrimary,
            borderWidth: '2px',
            _checked: {
                bg: 'transparent',
                borderColor: tokens.BorderPrimary,
                _before: {
                    bg: tokens.BorderPrimary,
                },
                _hover: {
                    boxShadow: 'none',
                    borderColor: tokens.BorderPrimary,
                    bg: 'transparent',
                },
            },
            _hover: {
                bg: 'transparent',
                borderColor: tokens.BorderPrimary,
                boxShadow: 'none',
            },
            _focusVisible: {
                outline: 'none',
                boxShadow: `0 0 0 ${tokens.Spacing01}px white, 0 0 0 ${tokens.Spacing02}px ${tokens.BorderPrimary}`,
            },
            _focus: {
                outline: 'none',
            },
        },
    },
});
export default radioStyles;
